<div
  class="sp-height__full sp-background__accent sp-position__fixed sp-position__top-no sp-position__bottom-no"
  [ngClass]="navbar_status == open_navbar_status ? 'sp-navbar__open' : 'sp-navbar__closed'">
  <div
    *ngIf="navbar_status == open_navbar_status"
    class="sp-width__full sp-toolbar__height sp-row__space sp-padding__horiz-x2">
    <img
      class="sp-logo__m"
      src="../../../assets/img/logo/sp-logo-light.svg" />

    <button
      mat-icon-button
      class="sp-icon__button sp-icon__button-light sp-margin__left-x2"
      (click)="onStatusChange()">
      <mat-icon class="material-symbols-outlined"> keyboard_double_arrow_left </mat-icon>
    </button>
  </div>

  <div
    *ngIf="navbar_status == closed_navbar_status"
    style="padding-top: 12px"
    class="sp-width__full sp-column__center">
    <img
      class="sp-logo__s"
      src="../../../assets/img/logo/sp-logo-light-short.svg" />

    <button
      mat-icon-button
      class="sp-icon__button sp-icon__button-light sp-margin__top"
      (click)="onStatusChange()">
      <mat-icon class="material-symbols-outlined"> keyboard_double_arrow_right </mat-icon>
    </button>
  </div>

  <div class="sp-margin__top-x4"></div>
  <app-navbar-menu
    [current_nav_item]="current_nav_item"
    [navbar_status]="navbar_status"></app-navbar-menu>
</div>
